import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';
import _ from 'lodash';
import { useIntegrations } from '~/contexts';

export default function useOpportunityFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      opportunityAmountGreaterThanOrEqual: null,
      opportunityHubspotSynced: null,
      opportunitySalesforceSynced: null,
      opportunityOwners: [],
      opportunityPractices: [],
      opportunityStages: [],
      opportunityStageCategories: [],
      opportunityTags: [],
      opportunityTypes: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const integrations = useIntegrations();

  const opportunitySearchParamsConfig = useMemo(
    () => ({
      opportunityAmountGreaterThanOrEqual: searchParamsConfig.opportunityAmountGreaterThanOrEqual,
      opportunitySalesforceSynced: searchParamsConfig.opportunitySalesforceSynced,
      opportunityHubspotSynced: searchParamsConfig.opportunityHubspotSynced,
      opportunityOwners: searchParamsConfig.opportunityOwners,
      opportunityPractices: searchParamsConfig.opportunityPractices,
      opportunityStages: searchParamsConfig.opportunityStages,
      opportunityStageCategories: searchParamsConfig.opportunityStageCategories,
      opportunityTags: searchParamsConfig.opportunityTags,
      opportunityTypes: searchParamsConfig.opportunityTypes,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback(
    (filters) => {
      return {
        opportunityAmountGreaterThanOrEqual: _.isNumber(filters?.opportunityAmountGreaterThanOrEqual)
          ? filters.opportunityAmountGreaterThanOrEqual
          : undefined,
        opportunitySalesforceSynced:
          integrations?.salesforce && filters.opportunitySalesforceSynced
            ? filters.opportunitySalesforceSynced
            : undefined,
        opportunityHubspotSynced:
          integrations?.hubspot && filters.opportunityHubspotSynced ? filters.opportunityHubspotSynced : undefined,
        opportunityOwnerId: filters.opportunityOwners?.map((owner) => owner.id),
        opportunityPracticeId: filters.opportunityPractices?.map((practice) => practice.id),
        opportunityStageId: filters.opportunityStages.length ? filters.opportunityStages.map((stage) => stage.id) : [],
        opportunityStageCategoryId: filters.opportunityStageCategories?.map((status) => status.id),
        opportunityTagId: filters.opportunityTags.length ? filters.opportunityTags.map((tag) => tag.id) : [],
        opportunityTypeId: filters.opportunityTypes?.map((type) => type.id),
      };
    },
    [integrations?.salesforce, integrations?.hubspot],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: opportunitySearchParamsConfig, mapUrlSearchParams }),
    [filters, opportunitySearchParamsConfig, mapUrlSearchParams],
  );
}
